import { StatusIntegrationLogEnum } from "@/main/services/enum/StatusIntegrationLogEnum";
import { getTranslateByKey } from "@/main/services/utils";
import { useStyles } from "./styles";

interface Props {
	status: number;
}

export default function StatusIntegrationLog(props: Props) {
	const classes = useStyles();
	const renderColor = () => {
		switch (props.status) {
			case StatusIntegrationLogEnum.Success:
				return "#00cc66";
			case StatusIntegrationLogEnum.Error:
				return "#ff0000";
			default:
				return "#00cc66";
		}
	};

	const renderName = () => {
		switch (props.status) {
			case StatusIntegrationLogEnum.Success:
				return getTranslateByKey("supplierInventoryImportStatus.success");
			case StatusIntegrationLogEnum.Error:
				return getTranslateByKey("supplierInventoryImportStatus.error");
		}
	};

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={renderName()}
			style={{ backgroundColor: renderColor(), width: "60px" }}
		>
			<span className={classes.spanContainer}>{renderName()}</span>
		</div>
	);
}
